import { render } from "./projectsSlide1.vue?vue&type=template&id=5f445387"
import script from "./projectsSlide1.vue?vue&type=script&lang=js"
export * from "./projectsSlide1.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__